// extracted by mini-css-extract-plugin
export var CTAButtonContainer = "CTAButton-module--CTAButtonContainer--3dE4t";
export var AltColor = "CTAButton-module--AltColor--2M3r9";